import type { ExistingOptionDefaultQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { HeaderActions } from "./header/actions";
import { useInitialized } from "../../../model/usecase/existing/use-init";
import { OptionForm } from "../../_shared/components/root";
import { standardOptionCategoriesAndManagerStore } from "../../_shared/store/categories";
import { ProductExistingOptionFormModelContextProvider } from "../context";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: ExistingOptionDefaultQuery;
};

export const OptionEditPresenter = ({ activeLangCode, navigator, serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = standardOptionCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const optionName = init.viewModel.name.value;

	return (
		<ProductExistingOptionFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="オプション編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={optionName} />

					<OptionForm roomCategoriesAndManagerStore={standardOptionCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingOptionFormModelContextProvider>
	);
};

OptionEditPresenter.displayName = "OptionEditPresenter";
